import { Injectable } from "@angular/core";
import { ActionItemLifeCycleModalValues } from "../../models/action-item-life-cycle-modal-values";
import { ActionItemConstants } from "../../constants/action-item-constants";

export abstract class ActionItemModal {
    abstract getModalValues() : ActionItemLifeCycleModalValues;
  }
  
  @Injectable({
    providedIn: 'any',
  })
  export class CompleteActionItemModal extends ActionItemModal {
    actionItemLifeCycleModalValues: ActionItemLifeCycleModalValues = {
        title : "",
        eSignText: "",
        inputLabel: "",
        buttonLabel: "",
        isInputMandatory: false,
        isInputFieldRequired:false
    };
    constructor() {
      super();
    }
    getModalValues(): ActionItemLifeCycleModalValues {
        this.actionItemLifeCycleModalValues.title = ActionItemConstants.ActionItem_CompleteModal_Title;
        this.actionItemLifeCycleModalValues.eSignText = ActionItemConstants.ActionItem_CompleteModal_ESign;
        this.actionItemLifeCycleModalValues.inputLabel = ActionItemConstants.ActionItem_CompleteModal_InputLabel;
        this.actionItemLifeCycleModalValues.buttonLabel = ActionItemConstants.ActionItem_SpeedDialButton_Complete;
        this.actionItemLifeCycleModalValues.isInputMandatory = true;
        this.actionItemLifeCycleModalValues.isInputFieldRequired = true;

        return this.actionItemLifeCycleModalValues;
    }
  }
  
  @Injectable({
    providedIn: 'any',
  })
  export class VoidActionItemModal extends ActionItemModal {
    actionItemLifeCycleModalValues: ActionItemLifeCycleModalValues = {
        title : "",
        eSignText: "",
        inputLabel: "",
        buttonLabel: "",
        isInputMandatory: false,
        isInputFieldRequired:false
    };
    constructor() {
      super();
    }
    getModalValues(): ActionItemLifeCycleModalValues {
        this.actionItemLifeCycleModalValues.title = ActionItemConstants.ActionItem_VoidModal_Title;
        this.actionItemLifeCycleModalValues.eSignText = ActionItemConstants.ActionItem_VoidModal_ESign;
        this.actionItemLifeCycleModalValues.inputLabel = ActionItemConstants.ActionItem_VoidModal_InputLabel;
        this.actionItemLifeCycleModalValues.buttonLabel = ActionItemConstants.ActionItem_SpeedDialButton_Void;
        this.actionItemLifeCycleModalValues.isInputMandatory = true;
        this.actionItemLifeCycleModalValues.isInputFieldRequired = true;

        return this.actionItemLifeCycleModalValues;
    }
  }
  
  @Injectable({
    providedIn: 'any',
  })
  export class DefferActionItemModal extends ActionItemModal {
    actionItemLifeCycleModalValues: ActionItemLifeCycleModalValues = {
        title : "",
        eSignText: "",
        inputLabel: "",
        buttonLabel: "",
        isInputMandatory: false,
        isInputFieldRequired:false
    };
    constructor() {
      super();
    }
    getModalValues(): ActionItemLifeCycleModalValues {
        this.actionItemLifeCycleModalValues.title = ActionItemConstants.ActionItem_DeferModal_Title;
        this.actionItemLifeCycleModalValues.eSignText = ActionItemConstants.ActionItem_DeferModal_ESign;
        this.actionItemLifeCycleModalValues.inputLabel = ActionItemConstants.ActionItem_DeferModal_InputLabel;
        this.actionItemLifeCycleModalValues.buttonLabel = ActionItemConstants.ActionItem_SpeedDialButton_Defer;
        this.actionItemLifeCycleModalValues.isInputMandatory = true;
        this.actionItemLifeCycleModalValues.isInputFieldRequired = true;

        return this.actionItemLifeCycleModalValues;
    }
  }
  
  @Injectable({
    providedIn: 'any',
  })
  export class VerifyActionItemModal extends ActionItemModal {
    actionItemLifeCycleModalValues: ActionItemLifeCycleModalValues = {
        title : "",
        eSignText: "",
        inputLabel: "",
        buttonLabel: "",
        isInputMandatory: false,
        isInputFieldRequired:false
    };
    constructor() {
      super();
    }
    getModalValues(): ActionItemLifeCycleModalValues {
        this.actionItemLifeCycleModalValues.title = ActionItemConstants.ActionItem_VerifyModal_Title;
        this.actionItemLifeCycleModalValues.eSignText = ActionItemConstants.ActionItem_VerifyModal_ESign;
        this.actionItemLifeCycleModalValues.inputLabel = ActionItemConstants.ActionItem_VerifierNotesModal_InputLabel;
        this.actionItemLifeCycleModalValues.buttonLabel = ActionItemConstants.ActionItem_SpeedDialButton_Verify;
        this.actionItemLifeCycleModalValues.isInputMandatory = true;
        this.actionItemLifeCycleModalValues.isInputFieldRequired = false;

        return this.actionItemLifeCycleModalValues;
    }
  }
  
  @Injectable({
    providedIn: 'any',
  })
  export class RejectActionItemModal extends ActionItemModal {
    actionItemLifeCycleModalValues: ActionItemLifeCycleModalValues = {
        title : "",
        eSignText: "",
        inputLabel: "",
        buttonLabel: "",
        isInputMandatory: false,
        isInputFieldRequired:false
    };
    constructor() {
      super();
    }
    getModalValues(): ActionItemLifeCycleModalValues {
        this.actionItemLifeCycleModalValues.title = ActionItemConstants.ActionItem_RejectModal_Title;
        this.actionItemLifeCycleModalValues.eSignText = ActionItemConstants.ActionItem_RejectModal_ESign;
        this.actionItemLifeCycleModalValues.inputLabel = ActionItemConstants.ActionItem_RejectModal_InputLabel;
        this.actionItemLifeCycleModalValues.buttonLabel = ActionItemConstants.ActionItem_SpeedDialButton_Reject;
        this.actionItemLifeCycleModalValues.isInputMandatory = true;
        this.actionItemLifeCycleModalValues.isInputFieldRequired = true;

        return this.actionItemLifeCycleModalValues;
    }
  }
  
  
  export const LabelMap = new Map<string, any>([
    ['Complete', CompleteActionItemModal],
    ['Void', VoidActionItemModal],
    ['Defer', DefferActionItemModal],
    ['Verify', VerifyActionItemModal],
    ['Reject', RejectActionItemModal]
  ]);
